import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function () {
  const $slider = $('#fmfVoicesSlider');
  const $prevBtn = $('#voicesPrevBtn');
  const $nextBtn = $('#voicesNextBtn');
  const $progressFill = $('#voicesProgressFill');

  if ($slider.length === 0) return;

  if (!$slider.hasClass('slick-initialized')) {
    $slider.slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
          },
        },
      ],
    });

    updateNavAndProgress();

    $slider.on('afterChange setPosition breakpoint', function () {
      updateNavAndProgress();
    });
  }

  function updateNavAndProgress() {
    if (!$slider.hasClass('slick-initialized')) return;

    const currentSlide = $slider.slick('slickCurrentSlide');
    const slick = $slider.slick('getSlick');
    const totalSlides = slick.slideCount;
    const slidesToShow = slick.options.slidesToShow;
    const maxIndex = Math.max(0, totalSlides - slidesToShow);

    // Arrow button states matching home-channels (.is-disabled vs .is-active)
    if (currentSlide === 0) {
      $prevBtn.removeClass('is-active').addClass('is-disabled');
    } else {
      $prevBtn.removeClass('is-disabled').addClass('is-active');
    }

    if (currentSlide >= maxIndex) {
      $nextBtn.removeClass('is-active').addClass('is-disabled');
    } else {
      $nextBtn.removeClass('is-disabled').addClass('is-active');
    }

    // Progress bar fill calculation
    if ($progressFill.length > 0) {
      const minPct = totalSlides > 0 ? (slidesToShow / totalSlides) * 100 : 100;
      const progress = maxIndex > 0
        ? minPct + (currentSlide / maxIndex) * (100 - minPct)
        : 100;
      $progressFill.css('width', progress + '%');
    }
  }

  $prevBtn.on('click', function (e) {
    e.preventDefault();
    if ($(this).hasClass('is-disabled')) return;
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('slickPrev');
    }
  });

  $nextBtn.on('click', function (e) {
    e.preventDefault();
    if ($(this).hasClass('is-disabled')) return;
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('slickNext');
    }
  });
});
